import {Component, OnInit, Input} from '@angular/core';
import {TileCollectionConfigurations} from './tile-collection.configurations';
import {KlaHttpService} from '../services/kla.http.service';
import {Image} from '../services/kla.data.models';
import { CommonModule } from '@angular/common';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { BadgesComponent } from '../badges/badges.component';
import { SocialMediaButtonsComponent } from '../social-media-buttons/social-media-buttons.component';
import { RouterModule } from '@angular/router';
import { PostGridComponent } from 'app/widgets/grid/postGrid/postGrid.component';
import { DynamicContentComponent } from '../../dynamic-content/dynamic-content.component'

@Component({
  selector: 'kla-tile-collection',
  templateUrl: './tile-collection.component.html',
  styleUrls: ['./tile-collection.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, StripSpecialCharsPipe, BadgesComponent, SocialMediaButtonsComponent, RouterModule, PostGridComponent, DynamicContentComponent ]
})
export class TileCollectionComponent implements OnInit {

  @Input()
  public config;

  constructor(private httpService: KlaHttpService) { }

  ngOnInit() {
    this.makeImagePaths();
  }

  navigate(url: string) {
    window.open(url, '_blank');
  }

  makeImagePaths() {
    for (let item of this.config.list) {
      item.image.width = item.image.width ? item.image.width : 500;
      if (item.image.crop_config && (item.image.width || item.image.height)) {
        const imageConfig: Image = {
          id:  item.image.id,
          width: + item.image.width,
          height: + item.image.height,
          cropConfig:  item.image.crop_config
        };
       item.image = this.httpService.getCroppedImagePath(imageConfig);
      } else {
        // @ts-ignore
        item.image = this.httpService.getImagePath(item.image.id, item.image.width);
      }
    }
  }
}
